var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2735 7.72065L8.2735 1.72065C8.0335 1.48065 7.70016 1.33398 7.3335 1.33398H2.66683C1.9335 1.33398 1.3335 1.93398 1.3335 2.66732V7.33399C1.3335 7.70065 1.48016 8.03399 1.72683 8.28065L7.72683 14.2807C7.96683 14.5207 8.30016 14.6673 8.66683 14.6673C9.0335 14.6673 9.36683 14.5207 9.60683 14.274L14.2735 9.60732C14.5202 9.36732 14.6668 9.03399 14.6668 8.66732C14.6668 8.30065 14.5135 7.96065 14.2735 7.72065ZM8.66683 13.3407L2.66683 7.33399V2.66732H7.3335V2.66065L13.3335 8.66065L8.66683 13.3407Z",
    fill: "#66686D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 5.33399C4.88578 5.33399 5.3335 4.88627 5.3335 4.33399C5.3335 3.7817 4.88578 3.33398 4.3335 3.33398C3.78121 3.33398 3.3335 3.7817 3.3335 4.33399C3.3335 4.88627 3.78121 5.33399 4.3335 5.33399Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/products-icon.7ec38807.svg";
export { ForwardRef as ReactComponent };